import proxybase from './proxybase';
import jwtDecode from 'jwt-decode';

class authService {
  login(body, redirect = true) {
    return proxybase
      .post('/auth/signin', body)
      .then((response) => {
        const lastLocation = sessionStorage.getItem('lastLocation');
        if (redirect) window.location.replace(lastLocation ?? '/');
        sessionStorage.removeItem('lastLocation');
        return Promise.resolve(response);
      })
      .catch((error) => {
        console.log(`An error occurred trying to loged in the user ${error}.`);
        return Promise.reject(error);
      });
  }
  requestPasswordReset(body) {
    return proxybase
      .post('/auth/reset-password', body)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }
  validatePasswordResetToken(token) {
    const encodedToken = encodeURIComponent(token);
    return proxybase
      .get(`/users/reset-password/${encodedToken}`)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }
  resetPasswordWithToken(body) {
    return proxybase
      .post(`/users/reset-password/reset`, body)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }
  getAllUsers() {
    return proxybase
      .post('/auth/getAllUsers')
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        console.log(`An error occurred trying to get all users ${error}.`);
        return Promise.reject(error);
      });
  }
  editUser(body) {
    return proxybase
      .put('/auth/editUser', body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  logout() {
    this.clearSession();
    window.location.replace('/login');
  }
  clearSession() {
    const { pathname, search } = window.location;
    const lastLocation = pathname !== '/login' ? pathname + search : '/';
    sessionStorage.setItem('lastLocation', lastLocation);
    localStorage.removeItem('userToken');
  }
  getSession() {
    return localStorage.getItem('userToken') || '';
  }
  getCurrentUser() {
    try {
      return jwtDecode(this.getSession() || '');
    } catch {
      return {};
    }
  }
}
const authServiceInstance = new authService();
export default authServiceInstance;
